module.exports = __webpack_public_path__ + "img/Icon-sidebar-actions.a356c2ad.svg";